module.exports = __webpack_public_path__ + "static/media/analytics.233e9388.png";